import {ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit,} from '@angular/core';
import {HeaderContent, VehicleDetailService} from './vehicle-detail/vehicle-detail.service';
import {Observable, Subscription} from 'rxjs';
import {ProgressBarService} from './progress-bar.service';
import {CardataWizardCommunicationService} from '@ucb2b/cardata-wizard';
import {Router, RouterLink, RouterLinkActive, RouterOutlet,} from '@angular/router';
import {VehicleListService} from './vehicle-list/vehicle-list.service';
import {AuthService} from './auth/auth.service';
import {NgxInitializerService} from './ngx-initializer.service';
import {TranslateModule} from '@ngx-translate/core';
import {MatProgressBar} from '@angular/material/progress-bar';
import {MatButton} from '@angular/material/button';
import {MatTabLink, MatTabNav, MatTabNavPanel} from '@angular/material/tabs';
import {MatToolbar, MatToolbarRow} from '@angular/material/toolbar';
import { AsyncPipe } from '@angular/common';
import {APP_CONFIG} from "./app.config";

@Component({
    selector: 'ucmim-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    MatToolbar,
    MatToolbarRow,
    MatTabNav,
    MatTabLink,
    RouterLinkActive,
    RouterLink,
    MatTabNavPanel,
    RouterOutlet,
    MatButton,
    MatProgressBar,
    AsyncPipe,
    TranslateModule
]
})
export class AppComponent implements OnInit, OnDestroy {
  private vehicleDetailService = inject(VehicleDetailService);
  private progressBarService = inject(ProgressBarService);
  private cardataWizardCommunicationService = inject(
    CardataWizardCommunicationService,
  );
  private router = inject(Router);
  private vehicleListService = inject(VehicleListService);
  private authService = inject(AuthService);
  private ngxInitializerService = inject(NgxInitializerService);

  title = 'ucmim-frontend';

  /**
   * True if application wide progress bar is to be shown.
   */
  showProgressBar = this.progressBarService.showProgressBar;

  /**
   * Current menu title.
   *
   * Return the selected model if a vehicle is selected, the application name otherwise.
   */
  headerText!: Observable<HeaderContent>;

  /**
   * True if there exists a valid JWT.
   */
  loggedIn!: Observable<boolean>;

  subscriptions: Subscription[] = [];

  isAdmin = false;
  public showDealerChange = false;
  public showSupportMode = false;

  readonly localeId = inject(APP_CONFIG).localeId;

  ngOnInit(): void {
    this.ngxInitializerService.init();
    this.headerText = this.vehicleDetailService.getHeaderText();

    this.subscriptions = [
      // go to vehicle list if output from tds-wizard is set
      this.cardataWizardCommunicationService
        .getOutput()
        .subscribe((carData) => {
          if (carData) {
            this.vehicleListService
              .saveCarData(carData)
              .subscribe((vehicleId) =>
                this.router.navigate(['/vehicles/' + vehicleId]),
              );
          }
        }),
    ];
    this.loggedIn = this.authService.isLoggedIn();
    this.isAdmin = this.authService.isUserAdmin();
    this.showDealerChange = this.authService.hasDealerChangePermission();
    this.showSupportMode = this.authService.inSupportMode();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  getActiveVehicleCount(): Observable<number> {
    return this.vehicleListService.getActiveVehicleCount();
  }

  clearSearchFilter(): void {
    this.vehicleListService.updateDeleteSearchObservable();
  }

  public changeDealer() {
    this.authService.changeDealer();
  }
}
